"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatFullTime = exports.formatCurrentTime = exports.formatTimeStamp = exports.formatMomentDate = exports.formatDateString = exports.formatShortMonthDayTime = exports.formatMomentDateAndTime = exports.formatMomentFullDateAndTimeWithoutSeconds = exports.formatMomentFullDateAndTime = exports.formatDateDayMonthYear = exports.formatDayMonthYear = exports.formatLocalUnixMonthOrdinalDayYear = exports.formatLocalUnixLongMonthDayCommaYearHourTime = exports.formatUnixLongMonthDayCommaYearHourTime = exports.formatUnixLongMonthDayCommaYear = exports.formatLongMonthDayCommaYear = exports.formatMonthDayCommaYear = exports.formatTimeStampToUnixMonthOrdinalDayYear = exports.formatUnixMonthOrdinalDayYear = exports.formatMonthOrdinalDayYear = exports.formatTime = exports.parseLocalISOString = exports.localDateFor = exports.zonedDateTimeForTimestamp = exports.zonedDateTimeFor = exports.utcDateTimeFor = exports.nowUtc = exports.now = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var config_1 = require("../config/config");
var now = function (timezone) { return moment_timezone_1.default().tz(timezone ? timezone : config_1.react_core_config.internalConfig.lotteryTimeZone); };
exports.now = now;
var nowUtc = function () { return moment_timezone_1.default.utc(); };
exports.nowUtc = nowUtc;
var utcDateTimeFor = function (date) { return moment_timezone_1.default.utc(date); };
exports.utcDateTimeFor = utcDateTimeFor;
var zonedDateTimeFor = function (date) { return moment_timezone_1.default(date).tz(config_1.react_core_config.internalConfig.lotteryTimeZone); };
exports.zonedDateTimeFor = zonedDateTimeFor;
var zonedDateTimeForTimestamp = function (timestamp) {
    return moment_timezone_1.default(timestamp).tz(config_1.react_core_config.internalConfig.lotteryTimeZone);
};
exports.zonedDateTimeForTimestamp = zonedDateTimeForTimestamp;
var localDateFor = function (date) { return moment_timezone_1.default(date).toDate(); };
exports.localDateFor = localDateFor;
var parseLocalISOString = function (date) {
    var ds = date.split(/\D/).map(function (s) { return parseInt(s, 10); });
    ds[1] = ds[1] - 1; // adjust month
    // @ts-ignore
    return new (Date.bind.apply(Date, __spreadArrays([void 0], ds)))();
};
exports.parseLocalISOString = parseLocalISOString;
var formatTime = function (time) { return moment_timezone_1.default(time).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format('hh:mm a'); };
exports.formatTime = formatTime;
var formatMonthOrdinalDayYear = function (date) {
    return moment_timezone_1.default(date).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format('MMM Do YYYY');
};
exports.formatMonthOrdinalDayYear = formatMonthOrdinalDayYear;
var formatUnixMonthOrdinalDayYear = function (timestamp) {
    return moment_timezone_1.default.unix(timestamp).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format('MMM Do YYYY');
};
exports.formatUnixMonthOrdinalDayYear = formatUnixMonthOrdinalDayYear;
var formatTimeStampToUnixMonthOrdinalDayYear = function (timestamp) { return moment_timezone_1.default(timestamp, 'YYYY-MM-DDTHH:mm:ss.sssZ').unix(); };
exports.formatTimeStampToUnixMonthOrdinalDayYear = formatTimeStampToUnixMonthOrdinalDayYear;
var formatMonthDayCommaYear = function (date) {
    return moment_timezone_1.default(date).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format('MMM DD, YYYY');
};
exports.formatMonthDayCommaYear = formatMonthDayCommaYear;
var formatLongMonthDayCommaYear = function (date) {
    return moment_timezone_1.default(date).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format('MMMM DD, YYYY');
};
exports.formatLongMonthDayCommaYear = formatLongMonthDayCommaYear;
var formatUnixLongMonthDayCommaYear = function (timestamp) {
    return moment_timezone_1.default.unix(timestamp).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format('MMMM DD, YYYY');
};
exports.formatUnixLongMonthDayCommaYear = formatUnixLongMonthDayCommaYear;
var formatUnixLongMonthDayCommaYearHourTime = function (timestamp) {
    return moment_timezone_1.default.unix(timestamp).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format('MMMM DD, YYYY hh:mm A');
};
exports.formatUnixLongMonthDayCommaYearHourTime = formatUnixLongMonthDayCommaYearHourTime;
var formatLocalUnixLongMonthDayCommaYearHourTime = function (timestamp) {
    return moment_timezone_1.default.unix(timestamp).format('MMMM DD, YYYY hh:mm A');
};
exports.formatLocalUnixLongMonthDayCommaYearHourTime = formatLocalUnixLongMonthDayCommaYearHourTime;
var formatLocalUnixMonthOrdinalDayYear = function (timestamp) { return moment_timezone_1.default.unix(timestamp).format('MMM Do YYYY'); };
exports.formatLocalUnixMonthOrdinalDayYear = formatLocalUnixMonthOrdinalDayYear;
var formatDayMonthYear = function (date) { return moment_timezone_1.default(date).parseZone().format('DD MMM YYYY'); };
exports.formatDayMonthYear = formatDayMonthYear;
var formatDateDayMonthYear = function (date) { return moment_timezone_1.default(date).parseZone().format('DD MMM YYYY'); };
exports.formatDateDayMonthYear = formatDateDayMonthYear;
var formatMomentFullDateAndTime = function (momentDateTime) {
    return momentDateTime.tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format('dddd, MMMM Do YYYY, h:mm:ss a');
};
exports.formatMomentFullDateAndTime = formatMomentFullDateAndTime;
var formatMomentFullDateAndTimeWithoutSeconds = function (date) {
    return moment_timezone_1.default(date).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format('MMMM Do, YYYY  h:mm A');
};
exports.formatMomentFullDateAndTimeWithoutSeconds = formatMomentFullDateAndTimeWithoutSeconds;
var formatMomentDateAndTime = function (date) {
    return moment_timezone_1.default(date).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format('MMMM Do YYYY, hh:mm');
};
exports.formatMomentDateAndTime = formatMomentDateAndTime;
var formatShortMonthDayTime = function (date) {
    return moment_timezone_1.default(date).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format('MMM DD, YYYY HH:mm:ss');
};
exports.formatShortMonthDayTime = formatShortMonthDayTime;
var formatDateString = function (date, formatter) {
    return moment_timezone_1.default(date).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format(formatter);
};
exports.formatDateString = formatDateString;
var formatMomentDate = function (date, formatter) {
    return date.tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format(formatter);
};
exports.formatMomentDate = formatMomentDate;
var formatTimeStamp = function (timestamp, formatter) {
    return moment_timezone_1.default.unix(timestamp).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format(formatter);
};
exports.formatTimeStamp = formatTimeStamp;
var formatCurrentTime = function (formatter, timezone) {
    return exports.now(timezone).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format(formatter);
};
exports.formatCurrentTime = formatCurrentTime;
var formatFullTime = function (date) {
    return moment_timezone_1.default(date).tz(config_1.react_core_config.internalConfig.lotteryTimeZone).format('HH:mm:ss');
};
exports.formatFullTime = formatFullTime;
//# sourceMappingURL=TimeUtil.js.map